import { render, staticRenderFns, recyclableRender, components } from "./openlogin.vue?vue&type=template&id=37fa5f60&scoped=true&"
var renderjs
import script from "./openlogin.vue?vue&type=script&lang=js&"
export * from "./openlogin.vue?vue&type=script&lang=js&"
import style0 from "./openlogin.vue?vue&type=style&index=0&id=37fa5f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa5f60",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/openlogin.vue"
export default component.exports